import { render, staticRenderFns } from "./CenterViewShippingPassword_Ap.vue?vue&type=template&id=5a37fef0&scoped=true"
import script from "./CenterViewShippingPassword_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewShippingPassword_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewShippingPassword_Ap.vue?vue&type=style&index=0&id=5a37fef0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a37fef0",
  null
  
)

export default component.exports